import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { InlineClientApplication } from '../api/agentStep.model';
import {
  getInlineClientApplicationDisplayName,
  getInlineClientApplicationLogoPath,
} from 'src/app/common/aiServiceUtils';

export const inlineClientApplicationSelectOptions: ISelectOption[] = Object.values(InlineClientApplication)
  .map((clientApplication) => ({
    id: `${FilterTypesEnum.InLineClientApplication}-${clientApplication}`,
    value: clientApplication,
    displayName: getInlineClientApplicationDisplayName(clientApplication),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.InLineClientApplication,
    categoryName: FilterTypesEnum.InLineClientApplication.toString(),
    iconPath: getInlineClientApplicationLogoPath(clientApplication),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName));
